var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurposeNotSpecifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8053 11.0689C26.7365 10.8578 26.5545 10.7038 26.334 10.6723L18.1732 9.48576L14.5238 2.09027C14.3278 1.69127 13.6733 1.69127 13.4785 2.09027L9.82685 9.48576L1.66601 10.6723C1.44668 10.7038 1.26351 10.8578 1.19468 11.0689C1.12701 11.2801 1.18418 11.5123 1.34285 11.6663L7.24851 17.4226L5.85435 25.5508C5.81701 25.7701 5.90685 25.9906 6.08651 26.1213C6.26735 26.2531 6.50418 26.2694 6.70135 26.1656L14 22.3284L21.2987 26.1668C21.3838 26.2123 21.4772 26.2344 21.5705 26.2344C21.6918 26.2344 21.812 26.1971 21.9135 26.1224C22.0932 25.9918 22.183 25.7713 22.1457 25.5519L20.7515 17.4238L26.6572 11.6663C26.8158 11.5123 26.873 11.2801 26.8053 11.0689Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurposeNotSpecifiedIcon);
export default __webpack_public_path__ + "static/media/purpose-not-specified-icon.e0b6111f3d8e0e7a500506b3cd18002f.svg";
export { ForwardRef as ReactComponent };